"use client";

import { c as _c } from "react/compiler-runtime";
import type { SearchEntityResult } from "fansunited-data-layer";
import type { FUSportsEventDetails } from "../data/types";
import { cn } from "@/utilities/core/cn";
import { useLabels } from "@/lib/labels/LabelsProvider";
interface Props {
  details: FUSportsEventDetails;
  entities: Record<string, SearchEntityResult>;
}
const KEY_EVENT_ICON: Record<string, string> = {
  GOAL: "⚽",
  OWN_GOAL: "⚽",
  PENALTY_GOAL: "⚽",
  MISSED_PENALTY: "✗",
  YELLOW_CARD: "🟨",
  SECOND_YELLOW_CARD: "🟨🟨",
  RED_CARD: "🟥",
  SUBSTITUTION: "↔",
  VAR: "🎥"
};

/** Non-football sports rarely have main_events populated; render only when present. */
export function MainEventsTimeline(t0) {
  const $ = _c(12);
  const {
    details,
    entities
  } = t0;
  const labels = useLabels();
  const {
    event
  } = details.data;
  if (event.mainEvents.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== labels.sportEventPage.mainEvents.title) {
    t1 = <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-muted-foreground">{labels.sportEventPage.mainEvents.title}</h2>;
    $[0] = labels.sportEventPage.mainEvents.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== entities || $[3] !== event.mainEvents) {
    let t3;
    if ($[5] !== entities) {
      t3 = (ev, i) => {
        const isRight = ev.competitorPosition === "TWO";
        const player = ev.primaryAthlete ? entities[ev.primaryAthlete]?.name : null;
        return <li key={`${ev.competitorId}-${ev.minute}-${i}`} className={cn("flex items-center gap-2 text-sm", isRight && "flex-row-reverse text-right")}><span className="w-10 shrink-0 text-center text-xs font-medium text-muted-foreground">{ev.minute}'</span><span className="shrink-0 text-lg" aria-hidden={true}>{KEY_EVENT_ICON[ev.type] ?? "\u2022"}</span><div className={cn("min-w-0 flex-1", isRight && "text-right")}><div className="truncate text-foreground">{player ?? readableType(ev.type)}</div>{ev.score && <div className="text-xs tabular-nums text-muted-foreground">{ev.score.competitorOne} - {ev.score.competitorTwo}</div>}</div></li>;
      };
      $[5] = entities;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = event.mainEvents.map(t3);
    $[2] = entities;
    $[3] = event.mainEvents;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <ul className="space-y-2">{t2}</ul>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <section className="rounded-lg border border-border bg-card p-4 shadow-sm">{t1}{t3}</section>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function readableType(type: string): string {
  return type.toLowerCase().split("_").map(s => s.length ? s[0].toUpperCase() + s.slice(1) : s).join(" ");
}